import * as api from '../api/import';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const VALUATION_IMPORTS_FETCH = createRequestTypes(
  'APPRAISAL/VALUATION_IMPORTS_FETCH',
);

export const fetchValuationImports = makeApiActionCreatorV3(
  api.fetchValuationImports,
  VALUATION_IMPORTS_FETCH[START],
  VALUATION_IMPORTS_FETCH[SUCCESS],
  VALUATION_IMPORTS_FETCH[ERROR],
);

export const VALUATION_IMPORT_FETCH = createRequestTypes(
  'APPRAISAL/VALUATION_IMPORT_FETCH',
);

export const fetchValuationImport = makeApiActionCreatorV3(
  api.fetchValuationImport,
  VALUATION_IMPORT_FETCH[START],
  VALUATION_IMPORT_FETCH[SUCCESS],
  VALUATION_IMPORT_FETCH[ERROR],
);

export const VALUATION_IMPORT_CREATE = createRequestTypes(
  'APPRAISAL/VALUATION_IMPORT_CREATE',
);

export const createValuationImport = makeApiActionCreatorV3(
  api.createValuationImport,
  VALUATION_IMPORT_CREATE[START],
  VALUATION_IMPORT_CREATE[SUCCESS],
  VALUATION_IMPORT_CREATE[ERROR],
);

export const VALUATION_IMPORT_UPDATE = createRequestTypes(
  'APPRAISAL/VALUATION_IMPORT_UPDATE',
);

export const updateValuationImport = makeApiActionCreatorV3(
  api.updateValuationImport,
  VALUATION_IMPORT_UPDATE[START],
  VALUATION_IMPORT_UPDATE[SUCCESS],
  VALUATION_IMPORT_UPDATE[ERROR],
);

export const VALUATION_IMPORT_ERRORS_FETCH = createRequestTypes(
  'APPRAISAL/VALUATION_IMPORT_ERRORS_FETCH',
);

export const fetchValuationImportErrors = makeApiActionCreatorV3(
  api.fetchValuationImportErrors,
  VALUATION_IMPORT_ERRORS_FETCH[START],
  VALUATION_IMPORT_ERRORS_FETCH[SUCCESS],
  VALUATION_IMPORT_ERRORS_FETCH[ERROR],
);
